import React, { useEffect, useState } from 'react';
import Select from "react-select";

import { useDispatch, useSelector } from "react-redux";
import { getLegacyEmpresas } from "../../slices/thunks";
import { setEmpresa } from '../../slices/context/reducer';

const EmpresaSelector = () => {
    const [empresaSeleccionada, setEmpresaSeleccionada] = useState(null);
    const [empresas, setEmpresas] = useState([])
    const tenantId = useSelector((state) => state.Context.tenantId)

    const empresasSelector = useSelector((state) => state.LegacyEmpresas.legacyEmpresas)
    const userInfo = useSelector((state) => state.UserInfo.userInfo)
    const dispatch = useDispatch();

    function parseEmpresa(empresa) {
        return { value: empresa?.CLAEMP, label: empresa?.NOMABR };
    }

    useEffect(() => {
        if (Array.isArray(empresasSelector) && empresasSelector?.length > 0) {
            setEmpresas(empresasSelector)
            let opcion = parseEmpresa(empresasSelector[0])
            setEmpresaSeleccionada(opcion);
            dispatch(setEmpresa(opcion.value))
        }
    }, [empresasSelector]);

    useEffect(() => {
        if (userInfo?.name && tenantId) {
            dispatch(getLegacyEmpresas({ tenantId, usuario: userInfo?.name }))
        }
    }, [userInfo, tenantId])

    const handleSelectEmpresa = (opcion) => {
        console.log(opcion);
        setEmpresaSeleccionada(opcion);
        dispatch(setEmpresa(opcion.value))
    };

    return (
        <React.Fragment>
            <Select
                id="empresas"
                placeholder="Empresas..."
                value={empresaSeleccionada}
                onChange={(opcion) => {
                    handleSelectEmpresa(opcion);
                }}
                options={empresas?.map(parseEmpresa)}
                onFocus={(e) => {
                    e.target.readOnly = true;
                }}
            />
        </React.Fragment>
    );
};

export default EmpresaSelector;